import { render } from "./ContractEditor.vue?vue&type=template&id=684d8575&scoped=true"
import script from "./ContractEditor.vue?vue&type=script&lang=js"
export * from "./ContractEditor.vue?vue&type=script&lang=js"

import "./ContractEditor.vue?vue&type=style&index=0&id=684d8575&scoped=true&lang=css"

import exportComponent from "/home/runner/work/somosteatro/somosteatro/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684d8575"]])

export default __exports__